const pick = require('../utils/pick');
const { PAGE_RENDER } = require('../../constants/initiatives');
const { getConfiguration } = require('../config');
const { METRICS } = require('../../constants/configurations');


const preparePayload = (settings, data) => {
  const metrics = getConfiguration(METRICS, PAGE_RENDER);
  const pageRenderMetrics = pick(data, metrics);

  if (!Object.keys(pageRenderMetrics).length) {
    throw new Error('Metrics not found');
  }

  return {
    name: PAGE_RENDER,
    data: pageRenderMetrics,
  };
};

module.exports = preparePayload;
